import { Box, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { useLazyDownloadInjectionGuideQuery } from "src/api/services/bucketApi";
import PdfIcon from "src/assets/icons/PdfIcon";
import injection from "src/assets/injection.png";
import injectionMobile from "src/assets/injection-mobile.png";
import { useIsMobile } from "src/hooks/useIsMobile";
import WhiteCard from "src/shared/components/WhiteCard";
import { useTranslation } from "react-i18next";
import { usePatient } from "src/context/PatientProvider";

const InjectionGuideCard = () => {
  const isMobile = useIsMobile();
  const [injectionGuide] = useLazyDownloadInjectionGuideQuery();
  const language = usePatient((patient) => patient.profile.language);
  const { t } = useTranslation();
  const component = "care.injectionGuideCard";

  const openPdf = useCallback(async () => {
    const newWindow = window.open("", "_blank");

    const pdfUrl = await injectionGuide({
      bucket: "resources",
      path:
        language === "es" ? "es-injection-guide.pdf" : "injection-guide.pdf",
    }).unwrap();

    if (pdfUrl && newWindow) {
      newWindow.location.href = pdfUrl;
    } else if (newWindow) {
      newWindow.close();
    }
  }, [injectionGuide, language]);

  return (
    <WhiteCard direction="row" justifyContent="space-between">
      <Stack gap={1}>
        <Typography variant="subtitle2">{t(`${component}.caption`)}</Typography>
        <Typography fontWeight={600}>{t(`${component}.text`)}</Typography>
      </Stack>
      <Box
        onClick={openPdf}
        width={isMobile ? "150px" : "362px"}
        sx={{
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            inset: 0,
            background: `url(${
              isMobile ? injectionMobile : injection
            }) lightgray 50% / cover no-repeat`,
            opacity: isMobile ? 1 : 0.5,
            zIndex: 0,
            borderRadius: "8px",
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        {isMobile ? null : (
          <Stack direction="row" alignItems="center" gap={1}>
            <PdfIcon sx={{ zIndex: 1 }} />
            <Typography color="#00B6B9" fontWeight={600} sx={{ zIndex: 1 }}>
              {t(`${component}.download`)}
            </Typography>
          </Stack>
        )}
      </Box>
    </WhiteCard>
  );
};

export default InjectionGuideCard;
